import { render, staticRenderFns } from "./EmailSenderPage.vue?vue&type=template&id=671840d5"
import script from "./EmailSenderPage.vue?vue&type=script&lang=js"
export * from "./EmailSenderPage.vue?vue&type=script&lang=js"
import style0 from "./EmailSenderPage.vue?vue&type=style&index=0&id=671840d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports